import { BorderBox } from "@/components/atoms/BorderBox";
import { crmRegistry } from "@/features/crm_system/lib/_core/crmRegistry";
import { QuestionsListRowProps, SurveyQuestionsOrSurveyBankQuestions } from ".";
import { QuestionWithDependents } from "@/features/question/hooks/useQuery/useGetQuestionsBySurveyId";

function hasDependents(question: SurveyQuestionsOrSurveyBankQuestions): question is QuestionWithDependents {
    return 'dependent_questions' in question;
}

export function QuestionsListRow({ question }: QuestionsListRowProps) {
    return (
        <li key={question.id} className="">
            <BorderBox size='sm' className="flex justify-between">
                <div className="col-span-2">
                    <p className="font-medium">Question:</p>
                    <p>{question.question}</p>
                </div>
                <div className="">
                    {question?.crm_system && (
                        <>
                            <p className="font-medium">Field type:</p>
                            <p>{crmRegistry.getFieldById(question.crm_system, question.field_type)?.name}</p>
                        </>
                    )}
                </div>
            </BorderBox>
            {hasDependents(question) && question.dependent_questions?.length > 0 && (
                <ul className="flex flex-col gap-2 pl-2 mt-2 ml-2 conditional-group-border">
                    {question.dependent_questions?.map((dependentQuestion) => (
                        <QuestionsListRow key={dependentQuestion.id} question={dependentQuestion} />
                    ))}
                </ul>
            )}
        </li>
    );
}